import { atom } from 'recoil';
import { ImageId } from '~/domain/changes/ids';

/**
 * The primary (and secondary) image held as a domain {@link ImageId}
 * rather than a live {@link Image3D} reference.
 *
 * UI state points at domain entities by id; it never owns them. Storing
 * the entity meant `dangerouslyAllowMutability: true` and left Recoil
 * holding a mutable aggregate member whose changes it could not observe —
 * and left the atom dangling at a deleted image. Use
 * `useSelectedPrimaryImage()` / `useSelectedSecondaryImage()` to resolve
 * the entity.
 */
export const primaryImageIdState = atom<ImageId | null>({
    key: 'primaryImageId',
    default: null,
});

export const secondaryImageIdState = atom<ImageId | null>({
    key: 'secondaryImageId',
    default: null,
});

// `imageListVersionState` used to live here: a hand-rolled counter that
// every call site had to remember to bump after mutating the patient
// aggregate. It is replaced by `useDomainVersion()`, which reads the
// DomainStore version that the ChangeTracker bumps automatically on every
// committed changeset — no call site can forget it.
